// extracted by mini-css-extract-plugin
export var alt = "ParagraphMerchandisingBlock-module--alt--c485c";
export var container = "ParagraphMerchandisingBlock-module--container--dea27";
export var creditCard = "ParagraphMerchandisingBlock-module--creditCard--1e805";
export var desktopOnly = "ParagraphMerchandisingBlock-module--desktopOnly--53311";
export var main = "ParagraphMerchandisingBlock-module--main--203ae";
export var mobileOnly = "ParagraphMerchandisingBlock-module--mobileOnly--52cec";
export var primaryButton = "ParagraphMerchandisingBlock-module--primaryButton--28517";
export var promotionLeftContent = "ParagraphMerchandisingBlock-module--promotionLeftContent--2cddb";
export var promotionTitle = "ParagraphMerchandisingBlock-module--promotionTitle--bfccf";
export var styledRow = "ParagraphMerchandisingBlock-module--styledRow--9d537";
export var textLeft = "ParagraphMerchandisingBlock-module--textLeft--98e15";
export var visuallyHidden = "ParagraphMerchandisingBlock-module--visuallyHidden--0cefd";